<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>LetFitBe</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="route in Routes" :key="route.path" flat :to="route.path">{{ route.title }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>
import router from './router'
export default {
  data () {
    return {
      Routes: router.options.routes
    }
  }
}

</script>

<style lang="scss">
</style>
